import {apiConstants, config, requestOptions, requestTypes, sendRequest} from "../../../../Utilities/Api";

class serverLoanLibraryCatalogItemApi {
    static getLoanLibraryCatalogItem(loanLibraryCatalogItemId: string) {
        return sendRequest(
            requestOptions(config.URL + `loan-library/catalog/${loanLibraryCatalogItemId}`,
                requestTypes.GET,
            ),
        );
    }

    static addLoanLibraryCatalogItemWithInventory(catalogWithInventory: Record<string, unknown>) {
        return sendRequest(
            requestOptions(config.URL + `loan-library/catalog`,
                requestTypes.POST,
                JSON.stringify(catalogWithInventory),
                apiConstants.successMessage.loanLibrary.CATALOG_ITEM_ADDED,
            ),
        );
    }

    static updateLoanLibraryCatalogItemWithInventory(catalogItemId: string, catalogWithInventory: Record<string, unknown>) {
        return sendRequest(
            requestOptions(config.URL + `loan-library/catalog`,
                requestTypes.PUT,
                JSON.stringify(catalogWithInventory),
                apiConstants.successMessage.loanLibrary.CATALOG_ITEM_UPDATED,
            ),
        );
    }
}

export const loanLibraryCatalogItemApi = config.environment.MODE === config.modes.SERVER ? serverLoanLibraryCatalogItemApi : serverLoanLibraryCatalogItemApi;
